export enum ValidationErrorCode {
    ACTIVATION_TOKEN_ALREADY_CONSUMED = 'ACTIVATION_TOKEN_ALREADY_CONSUMED',
    ACTIVATION_TOKEN_EXPIRED = 'ACTIVATION_TOKEN_EXPIRED',
    ALREADY_SCHEDULED_OSAS_QUESTIONNAIRE = 'ALREADY_SCHEDULED_OSAS_QUESTIONNAIRE',
    AUTOSUBSEQUENT_MISSING_PROVIDER = 'AUTOSUBSEQUENT_MISSING_PROVIDER',
    BAD_QUALITY_PASSWORD = 'BAD_QUALITY_PASSWORD',
    BAD_XML_DOCUMENT = 'BAD_XML_DOCUMENT',
    BATCH_DOES_NOT_HAVE_ANY_ERRORS = 'PAYOUT_DOES_NOT_HAVE_ANY_ERRORS',
    BRIGHTPLAN_ADD_ACTION_FAILED = 'BRIGHTPLAN_ADD_ACTION_FAILED',
    BRIGHTPLAN_AUTHENTICATION_FAILED = 'BRIGHTPLAN_AUTHENTICATION_FAILED',
    BRIGHTPLAN_GET_LOCATIONS_FAILED = 'BRIGHTPLAN_GET_LOCATIONS_FAILED',
    BRIGHTPLAN_GET_OPERATION_TYPES_FAILED = 'BRIGHTPLAN_GET_OPERATION_TYPES_FAILED',
    BRIGHTPLAN_GET_PROFESSIONALS_FAILED = 'BRIGHTPLAN_GET_PROFESSIONALS_FAILED',
    BRIGHTPLAN_GET_RELATIONS_FAILED = 'BRIGHTPLAN_GET_RELATIONS_FAILED',
    BRIGHTPLAN_USERNAME_NOT_FOUND = 'BRIGHTPLAN_USERNAME_NOT_FOUND',
    CANNOT_ADD_USER_TO_COMPLETED_GROUP_MEETING = 'CANNOT_ADD_USER_TO_COMPLETED_GROUP_MEETING',
    CANNOT_CHANGE_PATIENT_FROM_MDO_WITH_ASSOCIATED_REPORT = 'CANNOT_CHANGE_PATIENT_FROM_MDO_WITH_ASSOCIATED_REPORT',
    CANNOT_CLOSE_COMPLETED_GROUP_MEETING = 'CANNOT_CLOSE_COMPLETED_GROUP_MEETING',
    CANNOT_CLOSE_GROUP_MEETING_WITHOUT_ALL_PATIENTS_PRESENT = 'CANNOT_CLOSE_GROUP_MEETING_WITHOUT_ALL_PATIENTS_PRESENT',
    CANNOT_CLOSE_GROUP_MEETING_WITHOUT_ALL_REPORTS_SENT = 'CANNOT_CLOSE_GROUP_MEETING_WITHOUT_ALL_REPORTS_SENT',
    CANNOT_CLOSE_GROUP_MEETING_WITHOUT_PATIENTS = 'CANNOT_CLOSE_GROUP_MEETING_WITHOUT_PATIENTS',
    CANNOT_CREATE_GROUP_MEETING_ON_WEEKEND = 'CANNOT_CREATE_GROUP_MEETING_ON_WEEKEND',
    CANNOT_CREATE_GROUP_MEETING_WITH_PAST_DATE = 'CANNOT_CREATE_GROUP_MEETING_WITH_PAST_DATE',
    CANNOT_DELETE_COMPLETED_GROUP_MEETING = 'CANNOT_DELETE_COMPLETED_GROUP_MEETING',
    CANNOT_DELETE_GROUP_MEETING_WITH_PATIENTS = 'CANNOT_DELETE_GROUP_MEETING_WITH_PATIENTS',
    CANNOT_DELETE_RESOURCE_IN_USE = 'CANNOT_DELETE_RESOURCE_IN_USE',
    CANNOT_REMOVE_PATIENTS_FROM_COMPLETED_GROUP_MEETING = 'CANNOT_REMOVE_PATIENTS_FROM_COMPLETED_GROUP_MEETING',
    CANNOT_UPDATE_COMPLETED_DESKTOP_PROCESS = 'CANNOT_UPDATE_COMPLETED_PROCESS',
    CLOUDPAT_GET_PATIENT_FAILED = 'CLOUDPAT_GET_PATIENT_FAILED',
    CLOUDPAT_GET_SLEEP_STUDY_PDF_FAILED = 'CLOUDPAT_GET_SLEEP_STUDY_PDF_FAILED',
    CLOUDPAT_SUBSCRIBE_PATIENT_FAILED = 'CLOUDPAT_SUBSCRIBE_PATIENT_FAILED',
    CLOUDPAT_UPLOAD_SLEEP_STUDY_ASSET = 'CLOUDPAT_UPLOAD_SLEEP_STUDY_ASSET',
    CONSUMER_NOT_RECIPIENT = 'CONSUMER_NOT_RECIPIENT',
    CORRUPT_BANK_ACCOUNT_DATA = 'CORRUPT_BANK_ACCOUNT_DATA',
    CREDENTIALS_EXPIRED = 'CREDENTIALS_EXPIRED',
    DATE_OCCUPIED = 'DATE_OCCUPIED',
    DESKTOP_PROCESS_MISSING_HOLTER_SERIAL_NUMBER = 'DESKTOP_PROCESS_MISSING_HOLTER_SERIAL_NUMBER',
    DUPLICATE_RECORD = 'DUPLICATE_RECORD',
    END_DATE_CANNOT_BE_BEFORE_START_DATE = 'END_DATE_CANNOT_BE_BEFORE_START_DATE',
    EPISODE_CATEGORY_HAS_NO_PATIENT_TASKS = 'EPISODE_CATEGORY_HAS_NO_PATIENT_TASKS',
    ERROR_DISMISSAL_NOT_SUPPORTED_FOR_OTHER_THAN_PAYOUT_AND_INVOICE_BATCHES = 'ERROR_DISMISSAL_NOT_SUPPORTED_FOR_OTHER_THAN_PAYOUT_AND_INVOICE_BATCHES',
    ERROR_WHILE_PARSING = 'ERROR_WHILE_PARSING',
    EXPIRED = 'EXPIRED',
    EXPIRED_TOKEN = 'EXPIRED_TOKEN',
    EXTERNALID_EXISTS = 'EXTERNALID_EXISTS',
    FAILURE_DURING_PATIENT_LOOKUP = 'FAILURE_DURING_PATIENT_LOOKUP',
    GENDER_CAN_ONLY_BE_MALE_OR_FEMALE = 'GENDER_CAN_ONLY_BE_MALE_OR_FEMALE',
    GROUP_MEETING_AND_GROUP_MEETING_PATIENT_CANNOT_DIFFER_IN_TYPE = 'GROUP_MEETING_AND_GROUP_MEETING_PATIENT_CANNOT_DIFFER_IN_TYPE',
    HOLTER_DURATION_CANNOT_BE_FOURTEEN_DAYS = 'HOLTER_DURATION_CANNOT_BE_FOURTEEN_DAYS',
    IDENTIFIER_DECLARATION_EXISTS = 'IDENTIFIER_DECLARATION_EXISTS',
    IDENTIFIER_REGISTRATION_BIG_EXISTS = 'IDENTIFIER_REGISTRATION_BIG_EXISTS',
    IDENTIFIER_REGISTRATION_KP_EXISTS = 'IDENTIFIER_REGISTRATION_KP_EXISTS',
    IMAGE_MAX_FILESIZE_EXCEEDED = 'IMAGE_MAX_FILESIZE_EXCEEDED',
    IMPORT_DUPLICATE_FILE = 'IMPORT_DUPLICATE_FILE',
    IMPORT_WRONG_FILE_TYPE = 'IMPORT_WRONG_FILE_TYPE',
    IMPORT_WRONG_FIRST_ROW = 'IMPORT_WRONG_FIRST_ROW',
    IMPORT_WRONG_ORGANIZATION_ID = 'IMPORT_WRONG_ORGANIZATION_ID',
    IMPORT_WRONG_TXCS_ID = 'IMPORT_WRONG_TXCS_ID',
    INCORRECT_IBAN_NUMBER_FORMAT = 'INCORRECT_IBAN_NUMBER_FORMAT',
    INSURER_HAS_COUPLED_UZOVIES = 'INSURER_HAS_COUPLED_UZOVIES',
    INSURER_HAS_LINKED_DECLARATION_RULES = 'INSURER_HAS_LINKED_DECLARATION_RULES',
    INSURER_IS_BLOCKED = 'INSURER_IS_BLOCKED',
    INSURER_SERVICE_HAS_LINKED_DECLARATION_ACTIVITY_PERIODS = 'INSURER_SERVICE_HAS_LINKED_DECLARATION_ACTIVITY_PERIODS',
    INSURER_SERVICE_HAS_LINKED_PRICES = 'INSURER_SERVICE_HAS_LINKED_PRICES',
    INVALID_DESKTOP_PROCESS_ACTION = 'INVALID_DESKTOP_PROCESS_ACTION',
    INVALID_MANAGER_ROLE_ID = 'INVALID_MANAGER_ROLE_ID',
    INVALID_OSAS_SERVICE = 'INVALID_OSAS_SERVICE',
    INVALID_RECIPIENT = 'INVALID_RECIPIENT',
    INVALID_XML_DATA = 'INVALID_XML_DATA',
    MFA_REQUIRED_LOGIN_NOT_ALLOWED = 'MFA_REQUIRED_LOGIN_NOT_ALLOWED',
    MFA_SETUP_MANDATORY_LOGIN_NOT_ALLOWED = 'MFA_SETUP_MANDATORY_LOGIN_NOT_ALLOWED',
    MISSING_DATA = 'MISSING_DATA',
    MISSING_ORGANIZATION_OR_PRACTITIONER = 'MISSING_ORGANIZATION_OR_PRACTITIONER',
    MISSING_SERVICEORGANIZATIONSETTINGS = 'MISSING_SERVICEORGANIZATIONSETTINGS',
    MISSING_TOKEN = 'MISSING_TOKEN',
    MISSING_USERNAME_OR_PASSWORD = 'MISSING_USERNAME_OR_PASSWORD',
    MISSING_XML_AWS_ID = 'MISSING_XML_AWS_ID',
    NO_AGB_CODE = 'NO_AGB_CODE',
    NO_HOLTER_EXAMINATION_DURATION = 'NO_HOLTER_EXAMINATION_DURATION',
    NO_MATCH_DATE = 'NO_MATCH_DATE',
    NO_MATCH_DATE_BSN = 'NO_MATCH_DATE_BSN',
    NO_MEASUREMENTS_IN_PARSE_DATA = 'NO_MEASUREMENTS_IN_PARSE_DATA',
    NO_PASSWORD = 'NO_PASSWORD',
    NO_REQUEST_RECIPIENT = 'NO_REQUEST_RECIPIENT',
    NO_REQUESTED_BANK_ACCOUNT_DETAILS_CHANGE = 'NO_REQUESTED_BANK_ACCOUNT_DETAILS_CHANGE',
    NO_RERUN_FOR_COMPLETED_BATCHES = 'NO_RERUN_FOR_COMPLETED_BATCHES',
    NO_RERUN_FUNCTIONALITY_FOR_REQUESTED_BATCH_TYPE = 'NO_RERUN_FUNCTIONALITY_FOR_REQUESTED_BATCH_TYPE',
    NO_TESTDATA_PRESENT = 'NO_TESTDATA_PRESENT',
    NO_VALID_INSURANCE = 'NO_VALID_INSURANCE',
    NOT_CONSUMER_SUBSEQUENT_SERVICE = 'NOT_CONSUMER_SUBSEQUENT_SERVICE',
    NOT_FOUND = 'NOT_FOUND',
    NOT_VERIFIED = 'NOT_VERIFIED',
    ORGANIZATION_IS_NOT_REQUEST_RECIPIENT_FOR_AUTOSUBSEQUENT_SERVICE = 'ORGANIZATION_IS_NOT_REQUEST_RECIPIENT_FOR_AUTOSUBSEQUENT_SERVICE',
    ORGANIZATION_NOT_FOUND = 'ORGANIZATION_NOT_FOUND',
    OSASV_MISSING_OR_INCORRECT_SOMNOLOGY_ORGANIZATION_TYPE = 'OSASV_MISSING_OR_INCORRECT_SOMNOLOGY_ORGANIZATION_TYPE',
    OTP_SECRET_DOES_NOT_MATCH_TOTP_TOKEN = 'OTP_SECRET_DOES_NOT_MATCH_TOTP_TOKEN',
    OVERLAPPING_CONFIG = 'OVERLAPPING_CONFIG',
    PASSWORD_CONTAINS_FREQUENTLY_USED_PASSWORD = 'PASSWORD_CONTAINS_FREQUENTLY_USED_PASSWORD',
    PASSWORD_CONTAINS_PERSONAL_INFORMATION = 'PASSWORD_CONTAINS_PERSONAL_INFORMATION',
    PASSWORD_CONTAINS_REPEATED_SUBSEQUENCE = 'PASSWORD_CONTAINS_REPEATED_SUBSEQUENCE',
    PENDING_TOKEN = 'PENDING_TOKEN',
    PRACTITIONER_HAS_KSYOS_EMPLOYMENT = 'PRACTITIONER_HAS_KSYOS_EMPLOYMENT',
    PRACTITIONER_NOT_FOUND = 'PRACTITIONER_NOT_FOUND',
    PREVIOUSLY_USED_TOKEN = 'PREVIOUSLY_USED_TOKEN',
    PROCEDURE_COMPLETE_DOES_NOT_EXISTS_FOR_THIS_SERVICE = 'PROCEDURE_COMPLETE_DOES_NOT_EXISTS_FOR_THIS_SERVICE',
    PROCESS_ALREADY_TAKEN_BY_COLLEAGUE = 'PROCESS_ALREADY_TAKEN_BY_COLLEAGUE',
    PROCESS_HAS_NO_FUNDING_ERROR = 'PROCESS_HAS_NO_FUNDING_ERROR',
    RECENTLY_USED_TOTP_TOKEN = 'RECENTLY_USED_TOTP_TOKEN',
    REGISTRATION_CODE_EXPIRED = 'REGISTRATION_CODE_EXPIRED',
    RELATION_NUMBER_EXISTS = 'RELATION_NUMBER_EXISTS',
    REPROCESS_REASON_REQUIRED = 'REPROCESS_REASON_REQUIRED',
    REQUEST_ID_OR_PROCESSACTIVITY_ID_REQUIRED = 'REQUEST_ID_OR_PROCESSACTIVITY_ID_REQUIRED',
    REQUEST_SERVICE_CONSUMER_SUPERVISOR_MISSING = 'REQUEST_SERVICE_CONSUMER_SUPERVISOR_MISSING',
    REQUEST_SERVICE_CONSUMER_SUPERVISOR_NOT_ALLOWED = 'REQUEST_SERVICE_CONSUMER_SUPERVISOR_NOT_ALLOWED',
    REQUEST_SERVICE_CONSUMER_SUPERVISOR_NOT_VALID = 'REQUEST_SERVICE_CONSUMER_SUPERVISOR_NOT_VALID',
    REQUIRED = 'REQUIRED',
    SERVICE_ID_OR_SERVICE_CODE_REQUIRED = 'SERVICE_ID_OR_SERVICE_CODE_REQUIRED',
    SERVICE_NOT_AVAILABLE_FOR_THIS_PATIENT = 'SERVICE_NOT_AVAILABLE_FOR_THIS_PATIENT',
    SET_HARDWARE_TOKEN_EXPIRED = 'SET_HARDWARE_TOKEN_EXPIRED',
    SHORT_PASSWORD = 'SHORT_PASSWORD',
    STILL_ATTACHED_TO_SERVICEORGANIZATIONSETTINGS = 'STILL_ATTACHED_TO_SERVICEORGANIZATIONSETTINGS',
    STILL_PROVIDERS_ATTACHED = 'STILL_PROVIDERS_ATTACHED',
    TOO_MANY_ATTACHMENTS = 'TOO_MANY_ATTACHMENTS',
    UNEXPECTED_DESKTOP_PROCESS_STATUS_DURING_GET_HOLTER_CONFIG_FILES_DATA = 'UNEXPECTED_DESKTOP_PROCESS_STATUS_DURING_GET_HOLTER_CONFIG_FILES_DATA',
    UNKNOWN_HOLTER_EXAMINATION_DURATION = 'UNKNOWN_HOLTER_EXAMINATION_DURATION',
    UNKNOWN_MEASUREMENT = 'UNKNOWN_MEASUREMENT',
    UNKNOWN_PATIENTID = 'UNKNOWN_PATIENTID',
    UNKOWN_REQUESTER = 'UNKOWN_REQUESTER',
    USER_ALREADY_REGISTERED = 'USER_ALREADY_REGISTERED',
    USER_BLOCKED_TEMPORARILY = 'USER_BLOCKED_TEMPORARILY',
    USER_DOES_NOT_MATCH_TOKEN = 'USER_DOES_NOT_MATCH_TOKEN',
    USER_HAS_NO_EMPLOYMENT = 'USER_HAS_NO_EMPLOYMENT',
    USER_INFORMATION_IS_CORRUPT = 'USER_INFORMATION_IS_CORRUPT',
    USER_IS_NOT_ACTIVATED = 'USER_IS_NOT_ACTIVATED',
    USER_NOT_REGISTERED = 'USER_NOT_REGISTERED',
    USERNAME_EXISTS = 'USERNAME_EXISTS',
    USERNAME_NOT_FOUND = 'USERNAME_NOT_FOUND',
    USERNAME_OR_PASSWORD_INCORRECT = 'USERNAME_OR_PASSWORD_INCORRECT',
    VERY_SHORT_PASSWORD = 'VERY_SHORT_PASSWORD',
    WRONG_ACTIVITY_TYPE = 'WRONG_ACTIVITY_TYPE',
    WRONG_END_DATE = 'WRONG_END_DATE',
    WRONG_PASSWORD = 'WRONG_PASSWORD',
    WRONG_PASSWORD_WARNING = 'WRONG_PASSWORD_WARNING',
    WRONG_REGISTRATION_CODE = 'WRONG_REGISTRATION_CODE',
    WRONG_SERVICE_ACTIVITY = 'WRONG_SERVICE_ACTIVITY',
    WRONG_START_DATE = 'WRONG_START_DATE',
    WRONG_TIME_INPUT = 'WRONG_TIME_INPUT',
    WRONG_TOTP_TOKEN = 'WRONG_TOTP_TOKEN',
    WRONG_TOTP_TOKEN_WARNING = 'WRONG_TOTP_TOKEN_WARNING',
}
